<div class="modal-md sap-account-modal">
    <div class="modal-header state">
        <h1 class="modal-title text-truncate full-width text-align-center" id="modal-label"> <i class="fal fa-address-book"></i> {{operationType}} Payment Information </h1>
        <button type="button" (click)="close()" class="btn btn-icon close" aria-label="Close"><span class="fal fa-times" aria-hidden="true"></span></button>
    </div>
    <div class="modal-body">
        <app-sap-info [costCenter]="costCenter" (verifiedCostCenter)="onVerifiedSap($event)" #sapInfo></app-sap-info>
    </div>
</div>
